import * as React from 'react'
import { textBlockData } from '../../../blocks/custom_blocks/types.mod'


interface AboutPageProps {

  texts: textBlockData[]
}

/**
 * The About page can be created in the cms with the slugs, about, over-ons and uber-uns for the different languages. 
 * The page consists only out of Text Blocks, the first block will be rendered differently and treated as the intro, the rest will just be rendered.  
 *
 * @param props 
 * @returns 
 */
export const AboutPage = (props: AboutPageProps) => {
  //let textBlocks = props.s0.state.page.blocks.filter(b => b.kind == 'textBlock').toIndexedSeq().toArray() as Array<textBlockData>

  return <main className="main main--content theme--default">
    <div className="main__inner">
      <article className="content">
        <div className="content__inner">
          {props.texts.slice(0, 1).map(text => <header key='text-header' className="content__header">
            {text.value.fst.title && <h1 className="content__title typo--4xl">{text.value.fst.title}</h1>}
            {text.value.fst.text && <div className="content__intro typo--m" dangerouslySetInnerHTML={{ __html: text.value.fst.text }} />}
          </header>)}


          <div className="content__content text--styled">
            {props.texts.slice(1).map((text, i) => text.value.fst.text && <div key={i} dangerouslySetInnerHTML={{ __html: text.value.fst.text }} />)}
          </div>

        </div>
      </article>
    </div>
  </main>
}